import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getPerformanceObject } from '../../../utils/window-helper';
export var bundleEvalTimings = function bundleEvalTimings(data, _bundleEvalTimings) {
  var performance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getPerformanceObject() || undefined;
  if (!_bundleEvalTimings) {
    return null;
  }
  var started = {};
  var timings = {};
  performance === null || performance === void 0 || performance.getEntriesByType('mark').forEach(function (mark) {
    var result = _bundleEvalTimings.mapPerformanceMark(mark.name);
    if (!result || data.result.startTime === null) {
      return;
    }
    var type = result.type,
      name = result.name;
    if (type === 'start' && mark.startTime >= data.result.startTime) {
      started[name] = mark;
      return;
    }
    if (type === 'end' && started[name]) {
      timings[name] = {
        startTime: Math.round(started[name].startTime - data.result.startTime),
        duration: Math.round(mark.startTime - started[name].startTime)
      };
      delete started[name];
    }
  });
  if (_bundleEvalTimings !== null && _bundleEvalTimings !== void 0 && _bundleEvalTimings.additionalTimings && data.result.startTime !== null) {
    var result = _bundleEvalTimings.additionalTimings(data.result.startTime);
    if (result) {
      Object.entries(result).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        timings[key] = value;
      });
    }
  }
  if (Object.keys(timings).length === 0) {
    return null;
  }
  return {
    'timings:bundleEval': timings
  };
};